module.exports = __webpack_public_path__ + "img/banner.c19bb0cc.jpg";